import { render, staticRenderFns } from "./BlocosBlog.vue?vue&type=template&id=a16916fa&scoped=true"
import script from "./BlocosBlog.vue?vue&type=script&lang=js"
export * from "./BlocosBlog.vue?vue&type=script&lang=js"
import style0 from "./BlocosBlog.vue?vue&type=style&index=0&id=a16916fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16916fa",
  null
  
)

export default component.exports